
<template>
	<div class="page-container">
		
		<HeaderLayout :pagecode="'join'"></HeaderLayout>
		<div class="content">
		    <div class="main-content">
				<h2 class="text-name">안녕하세요!</h2>
				<p class="text-name-1">회원가입을 하고인공지능 선생님을 만나보세요.</p>
				<form  id="submitForm" action="memberProc/registMember" novalidate @submit="formSubmit">
				<div class="from-box">
					<div class='form-group'>   
						<label class="text-label">이름</label>
						<div class="text-input" >
							 <input :required="true" placeholder="이름을 입력해주세요" type="text" autocomplete="off" name="name"  id="name"/>
						</div>
						<div class="md-error-box">이름을 입력하세요</div>
					</div>
					<div class='form-group'>   
						<label class="text-label">연락처</label>
						<div class="text-input" >
						<input :required="true" placeholder="연락처를 입력해주세요" type="text" autocomplete="off" name="pcs" id="pcs"/>
						</div>
						<div class="md-error-box">연락처를 입력하세요</div>
					</div>
				    <div class='form-group'>   
						<label class="text-label">이메일</label>
						<div class="text-select">
							<input :required="true" type="text" autocomplete="off" name="emailpree" id="emailpree">
							<span class="text-a">@</span>
							<select :required="true"  name="emailtail" id="emailtail">
								 <option value="">선택</option>
								 <option value="naver.com">naver.com</option>
								 <option value="gmail.com">gmail.com</option>
								 <option value="hanmail.net">hanmail.net</option>
								 <option value="nate.com">nate.com</option>
								 <option value="paran.com">paran.com</option>
							</select>
						</div>
						<div class="md-warning-box" id="userEmail-warning">{{userEmailMessage}}</div>
						<div class="md-error-box">이메일을 입력하세요</div>
					</div>
					<div style='height:10px;'></div>
					<!--div class='form-group'>   
						<label class="text-label">주소</label>
						<div class="text-select-1" >
				  			<input :required="true" style="width:70%;max-width:70%;" type="text" autocomplete="off" name="addr1" id="addr1">
							<span class="box-adder" @click="openPost()">우편번호</span>
						</div>
						<div class="md-error-box" style='margin-top:5px;'>주소를 입력하세요</div>
						
					</div>
					<div class='form-group'>   
						<div class="text-input" >
				  			<input :required="true" type="text" autocomplete="off" name="addr2" id="addr2" placeholder="상세주소를 입력해주세요.">
						</div>
						<div class="md-error-box">상세주소를 입력하세요</div>
					</div-->
					<div class='form-group'>   
					    <label class="text-label">아이디</label>
						<div class="text-input" >
							<input type="text" :required="true" placeholder="아이디를 입력하세요" v-model="userId" autocomplete="off" name="uid" id="uid"/>
						</div>
						<div class="md-warning-box" id="userId-warning">{{userIdMessage}}</div>
						<div class="md-error-box"></div>
					</div>
					<div style='height:10px;'></div>
					<div class='form-group'>   
						<label class="text-label">패스워드</label>
						<div class="text-input" >
							<input :required="true" :option="'userpw'" type="password" name="upass" id="upass"/>
						</div>
						<div class="md-warning-box">8~15자의 영문자와 숫자 특수문자의 조합</div>
						<div class="md-error-box">패스워드를 입력하세요</div>
					</div>
					<div style='height:10px;'></div>
					<div class='form-group'>   
						<label class="text-label">패스워드확인</label>
						<div class="text-input" >
							<input :required="true"   :match="'#upass'" type="password" name="repass" id="repass" />
						</div>
						<div class="md-warning-box fail-warning-hide">비밀번호와 비밀번호확인이 일치하지 않습니다</div>
						<div class="md-error-box">패스워드확인을 입력하세요</div>
					</div>
						
					<div class="box-check">
				  		<input type="checkbox" v-model="agree">
						<span class="text-check" @click="showAgree('agree')">이용약관</span> 및 <span class="text-check" @click="showAgree('private')">개인 정보처리 방침에</span>동의합니다.</span>
					</div>
					<div style='height:2px;'></div>
					<div class="box-button">
				        <md-button class="md-raised md-accent"  style='width:100%;margin:0;height:50px;' type="submit">가입하기</md-button>
					</div>
				</div>
				</form>		
				<div class="box-border">
				       <ul>
				           <li></li>
						   <li><span class="text-OR">OR</span></li>
						   <li></li>
					   </ul>
				  </div>
				  <div class="box-button-img" v-if="naverView">
				       <button type="button" style="background:#22B600;color:#fff;"  @click="snsLogin('nv')"><img src="../../assets/img/btn-naver.png" width=15 height=15> 네이버 아이디로 가입</button>
				  </div>
				  <div class="box-button-img" v-if="facebookView">
				       <button type="button" style="background:#5471AD;color:#fff;"  @click="snsLogin('fb')"><img src="../../assets/img/btn-facbook.png" width=8 height=8> 페이스북 아이디로 가입</button>
				  </div>
				  <div class="box-button-img"  v-if="kakaoView">
				       <button type="button" style="background:#FEF200;color:#fff;"  @click="snsLogin('ko')"><img src="../../assets/img/btn-talk.png" width=20 height=20> 카카오톡 아이디로 가입</button>
				  </div>

			</div>
		</div>


		<div class="screen-layout" v-if="screenView">
			<div class="agreeLayout">
				<div class="close-box" @click="hideAgree()">
					<i class="fa fa-times"></i>
				</div>
				<h2>{{agreeTitle}}</h2>
				<div class="agreeText" v-html="agreeContent"></div>
					
			</div>
		</div>
		<FooterLayout></FooterLayout>
	</div>	
	
</template>

<script>
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'

export default {
  name: 'MemberJoin',
  components: {
	  HeaderLayout,
	  FooterLayout,
  },
  data () {
	
	return {
  	   userId:null,
	   userIdMessage:'',
	   userIdFlag:false,
	   userIdSend:false,
	   snsInfo:{},
		facebookView:true,
		naverView:true,
		kakaoView:true,
	   agree:false,
	   screenView:false,
	   agreeTitle:'',
	   agreeContent:'',
	   agreeInfo:{},
	   userEmail:null,
	   userEmailMessage:'',
	   userEmailFlag:false,
	   userEmailSend:false,
	 
	   
   }
  },
  watch: {
	userId() {
		this.checkId();	
	},
	//userEmail() {
	//	this.checkEmail();	
	//},
	
  },
  created: function() {
	  if(sessionStorage.getItem('memberkey')) {
		  this.$router.push({path:'/'});
		  return;
	  }
	  this.getData();
  },
  methods: {
	   getData() {  
			var obj = this;
			this.$form.sendPost({},'memberProc/getAgreeInfo',function(response) {
				 obj.snsInfo	= response.snsInfo;
				 if(obj.snsInfo.use_ka!='yes') {
					obj.kakaoView = false;
				 }
				 if(obj.snsInfo.use_nv!='yes') {
					obj.naverView = false;
					
				 }
				 if(obj.snsInfo.use_fb!='yes') {
					obj.facebookView = false;
				 }
				 obj.agreeInfo = response.agreeInfo;
			});	
	  },
	  checkId() {
			if(this.userId && !this.userIdSend) {
			    if(!this.$form.isValidUserid(this.userId)) {
					$('#userId-warning').removeClass('succ-warning').removeClass('fail-warning');
					this.userIdMessage = '아이디는 4~15자 사이의 영문소문자 또는 영문소문자+숫자 조합만 가능합니다';
					this.userIdFlag = false;
					return;
				}
				this.userIdSend = true;
				
				var obj = this;
				this.$form.sendPost({uid:this.userId},'memberProc/getCheckId',function(response) {
					obj.userIdSend = false;
					console.log(response);
					if(response.result=='succ') {
						obj.userIdMessage = '아이디 사용이 가능합니다';
						$('#userId-warning').removeClass('fail-warning').addClass('succ-warning');
						obj.userIdFlag = true;
					} else {
						obj.userIdMessage = '중복된 아이디가 존재합니다';
						$('#userId-warning').removeClass('succ-warning').addClass('fail-warning');
						obj.userIdFlag = false;
					}
					
				});
			 } else {
				this.userIdSend = false;
				this.userIdMessage = '';
				$('#userId-warning').removeClass('succ-warning').removeClass('fail-warning');
				
			 }
	  },
	  openPost() {

		execDaumPostcode();
	  },
	  checkEmail() {
			if(this.userEmail && !this.userEmailSend) {
			    if(!this.$form.isValidEmail(this.userEmail)) {
					$('#userEmail-warning').removeClass('succ-warning').removeClass('fail-warning');
					this.userEmailMessage = '잘못된 이메일 형식입니다';
					this.userEmailFlag = false;
					return;
				}
				this.userEmailSend = true;
				
				var obj = this;
				this.$form.sendPost({email:this.userEmail},'memberProc/getCheckEmail',function(response) {
					obj.userEmailSend = false;
					if(response.result=='succ') {
						obj.userEmailMessage = '이메일 사용이 가능합니다';
						$('#userEmail-warning').removeClass('fail-warning').addClass('succ-warning');
						obj.userEmailFlag = true;
					} else {
						obj.userEmailMessage = '중복된 이메일이 존재합니다';
						$('#userEmail-warning').removeClass('succ-warning').addClass('fail-warning');
						obj.userEmailFlag = false;
					}
					
				});
			 } else {
				this.userEmailSend = false;
				this.userEmailMessage = '';
				$('#userEmail-warning').removeClass('succ-warning').removeClass('fail-warning');
				
			 }
	  },
	  formSubmit(e) {
		var $f = $('#submitForm');
		if(this.userId && !this.userIdFlag) {
			$('#userId-warning').addClass('fail-warning');
			$('#uid').focus();
			e.preventDefault();
			return;
		}
		//if(this.userEmail && !this.userEmailFlag) {
		//	$('#userEmail-warning').addClass('fail-warning');
		//	$('#email').focus();
		//	e.preventDefault();
		//	return;
		//}
		
		if(!this.agree) {
			var params = {}
			params.content = '약관에 동의하세요';	
			this.$eventBus.$emit('dialogOpen',params);
			e.preventDefault();
			return;
		}
		var obj = this;
		this.$form.validate($f,e,function(resp) {
			obj.completeJoin(resp);
			
		})
		
		e.preventDefault();
		return;
		
		
	  },
	  completeJoin(resp) {
		  var result = resp.result;
		  var params = {};
		  switch(result) {
			  case 'doubleId':
			  	params.content = '중복된 아이디입니다';
			  break;
			  case 'doubleEmail':
				params.content = '중복된 이메일입니다';
			  break;
			  case 'noneEmail':
				params.content = '이메일을 입력하세요';
			  break;
			  case 'succ':
				sessionStorage.setItem('memberkey',resp.memberkey);
				sessionStorage.setObject('memberInfo',resp.userInfo);
				
				this.$router.push({path:'/'})
				return;
			  break;
			  default:
				params.content = '시스템 에러';	
			  break;
			  
		  }
		  this.$eventBus.$emit('dialogOpen',params);
		  
	  },
	  snsLogin(type) {
		    var info = this.snsInfo;
			var url = this.$VARS.url+'/memberProc/snsCallBack?type=';

			switch(type) {
				case 'nv': // 네이버
					if(!info.key_nv || !info.pw_nv || !info.token_nv) {
						var params = {};
						params.content = '네이버 로그인을 이용할수 없습니다';
						this.$eventBus.$emit('dialogOpen',params);
						return;
					}
					url+= 'n';
					location.href = 'https://nid.naver.com/oauth2.0/authorize?client_id='+info.key_nv+'&response_type=code&redirect_uri='+encodeURIComponent(url)+'&state='+info.token_nv;
				break;
				case 'ko': // 카카오
					
					if(!info.key_ka) {
						var params = {};
						params.content = '카카오톡 로그인을 이용할수 없습니다';
						this.$eventBus.$emit('dialogOpen',params);
						return;
					}
					
					location.href = "https://kauth.kakao.com/oauth/authorize?client_id="+info.key_ka+"&redirect_uri="+url+"k&response_type=code";
					
				break;
				case 'fb': // 페이스북
					if(!info.key_fb || !info.pw_fb) {
						var params = {};
						params.content = '페이스북 로그인을 이용할수 없습니다';
						this.$eventBus.$emit('dialogOpen',params);
						return;
					}
					location.href = "https://graph.facebook.com/oauth/authorize?client_id="+info.key_fb+"&redirect_uri="+url+"f&scope=email,public_profile";
				break;
			}
	  },
	   showAgree(cmd) {
			switch(cmd) {
				case 'agree':
					this.agreeTitle = '이용약관';
					this.agreeContent = this.agreeInfo.agree1;
				break;
				case 'private':
					this.agreeTitle = '개인정보 취급방침';
					this.agreeContent = this.agreeInfo.agree2;
				break;
			
			}
			this.screenView = true;
			
	  },
	  hideAgree() {
			this.screenView = false;
	  }

  },
  mounted: function() {

	$('.page-container').css('min-height',$(window).height());
	$('.text-input input').focus(function() {
		$(this).parent().addClass('md-focused');
	});
	$('.text-input input').blur(function() {
		$(this).parent().removeClass('md-focused');
	});
	$('.text-select input,select').focus(function() {
		$(this).addClass('md-focused');
	});
	$('.text-select input,select').blur(function() {
		$(this).removeClass('md-focused');
	});
	
	$('.text-select-1 input').focus(function() {
		$(this).parent().addClass('md-focused');
	});
	$('.text-select-1 input').blur(function() {
		$(this).parent().removeClass('md-focused');
	});
	
  },
  updated() {
		
	
  }

}
</script>

<style lang="scss" scoped>

.page-container {
	width:100%;
	background:#fff;
	margin:0;
	min-height:calc(100vh);
	.content {
		width:100%;
		height:auto;
		padding:150px 0 100px; 
		font-family: 'Nanum Gothic', sans-serif;
		background:#fff;
		.main-content {
			width:400px;
			margin:0 auto;
			.text-name {
				font-size:26px;
				font-weight:normal;
				color:#414141;
				line-height:100%;
				margin-bottom:0;
			}
			.text-name-1	{
						margin-top:15px;
						color:#B3B3B3;
						font-size:11px;
						padding-bottom:30px;
						line-height:13pt;
			}
			.text-label			{
						color:#B3B3B3;
						font-size:13px;
						
			}
			.text-input		     {
						padding:12px 0;
						border-bottom:1px solid #EDEDED;
						margin-bottom:12px;
						input			{
								width:100%;
								border:none;
								outline:none;
								color:#000;
						}
						
			}
		
			.text-input.md-focused {
				border-bottom:2px solid #3D79FE;
	
			}
			.text-select		{
						padding:10px 0;
						width:100%;
						input      {
								padding:13px 0;
								border:none;
								outline:none;
								border-bottom:1px solid #EDEDED;
								width:45%;
						}
						input.md-focused {
							border-bottom:2px solid #3D79FE;
						}
						.text-a      {
								width:10%;
								font-size:18px;
								display:inline-block;
								text-align:center;
						}
						select      {
								padding:13px 0;
								border:none;
								outline:none;
								border-bottom:1px solid #DEDEDE;
								width:45%;
								font-size:12px;
								
						}
						select.md-focused {
							border-bottom:2px solid #3D79FE;
						}
			}
			.text-select-1  {
						padding:20px 0;
						border-bottom:1px solid #EDEDED;
						width:100%;
						position:relative;
						input  {
						         width:70%;
								 border:none;
								 outline:none;
						}
						.box-adder		{
								 width:90px;
								 padding:5px;
								 border-radius:20px;
								 border:1px solid #DEDEDE;
								 display:inline-block;
								 text-align:center;
								 font-size:12px;
								 position:absolute;
								 right:5px;
								 cursor:pointer;
								
						}
			}
			.text-select-1.md-focused {
				border-bottom:2px solid #3D79FE;
	
			}
			.text-box-input          {
						padding:12px 0;
						border-bottom:1px solid #EDEDED;
						margin-bottom:12px;
						input          {
								width:100%;
								border:none;
								outline:none;
								color:#000;
						}
			}
			.box-check       {
					  margin-bottom:12px;
					  font-size:13px;
					  input      {
					  		  width:15px;
							  height:15px;
							  vertical-align:-2px;
							  margin-right:5px;
							  word-spacing:-3px; 
					  }
					  .text-check     {
					  		  color:#3D79FE;
							  cursor:pointer;
					  }
					  .midder-border      {
					           width:100%;
							   .border-1    {
							   			display:inline-block;
										width:11%;
										height:1px;
										background:#3D79FE;
										position:absolute;
										left:47px;
										
							   }
							    .border-2    {
							   			display:inline-block;
										width:30%;
										height:1px;
										background:#3D79FE;
										position:absolute;
										left:110px;
										
							   }
					  }
			}
			.box-button        {
			          width:100%;
					  margin-top:20px;
					  button      {
							width:100%;
						    padding:10px;
							background:#3D79FE;
					        color:#fff;
							border-radius:30px;
							border:none;
							outline:none;
							font-size:13px;
					  }
			}
			.box-border        {
					 width:100%;
					 margin:30px auto;
					 ul           {
					      display:flex;
					      li         {
						          width:42%;
			                      border-bottom:1px solid #CBCBCB;
								  position:relative;
								  text-align:center;
								  &:nth-child(2)        {
								           width:16%;
										   border-bottom:none;
										  .text-OR     {
										           position:absolute;
												   top:-12px;
												   width:20%;
												   left:13px;
										  }
								  }
					            
						   }
					}
			}
			.box-button-img         {
			           width:100%;
					   margin-bottom:20px;
					   button      {
							width:100%;
						    padding:11px;
					        color:#fff;
							border-radius:30px;
							border:none;
							outline:none;
							font-size:13px;
							text-align:center;
							line-height:20px;
							img     {
							     margin-right:5px;
							}
					  }
					  &:last-child     {
					         margin-bottom:35px;
					         button      {
							       color:#3B1F1F; 
								   font-weight:bold;
							 }
					  }
			}
		}
	}
	.screen-layout {
		width:100%;
		height:calc(100vh);
		background:rgba(0,0,0,.7);
		position:fixed;
		top:0;
		left:0;
		z-index:100000;
		.agreeLayout {
			width:700px;
			margin:150px auto 0 auto;
			background:#fff;
			padding:20px;
			position:relative;
			.close-box {
				position:absolute;
				top:5px;
				right:10px;
				text-align:center;
				line-height:40px;
				font-size:20pt;
				cursor:pointer;
				z-index:10000;
			}
			h2 {
				margin:10px 0 10px 0;
				font-size:16pt;
				text-align:center;
			}
			.agreeText {
				height:500px;
				overflow-x:hidden;
				overflow-y:auto;
				padding:10px;
				border:solid 1px #dcdcdc;
			}
		}
	}
	
}


</style>